exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vd-picker__input {\n  border: 1px solid #d8d6de;\n  border-radius: 0.357rem;\n  padding: 0.1rem 0.7rem;\n}\n.vs__selected-options {\n  padding: 3px 2px !important;\n}\n.btn-primary {\n  border-color: #152848 !important;\n  background-color: #152848 !important;\n}\ninput[type=search] {\n  border: none !important;\n  background: none !important;\n  padding: 0px !important;\n}\n.btn-block {\n  width: 100%;\n}\n", ""]);

// exports
